import { cloneDeep, isNull } from 'lodash';

export default {
  props: {
    value: null,
    toggleLabel: {
      type: String,
      required: true,
    },
    overriddenDefault: null,
  },
  data() {
    return {
      isOverridden: !isNull(this.value),
      prevValue: cloneDeep(this.value || this.overriddenDefault),
    };
  },
  watch: {
    value(value, oldValue) {
      this.isOverridden = !isNull(value);
      if (!isNull(oldValue)) {
        this.prevValue = cloneDeep(oldValue || this.overriddenDefault);
      }
    },
  },
  methods: {
    onInput(event) {
      if (event.target.checked) {
        this.$emit('input', this.prevValue);
        this.$emit('change', this.prevValue);
      } else {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/InheritanceToggle.js